import { render, staticRenderFns } from "./vuetiform-color.vue?vue&type=template&id=24b7bb2b&scoped=true&"
import script from "./vuetiform-color.vue?vue&type=script&lang=js&"
export * from "./vuetiform-color.vue?vue&type=script&lang=js&"
import style0 from "./vuetiform-color.vue?vue&type=style&index=0&id=24b7bb2b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../@vue-modules/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b7bb2b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../@vue-modules/vuetify/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VColorPicker } from 'vuetify/lib/components/VColorPicker';
installComponents(component, {VColorPicker})
